import { BUILDINGS_QUERY_KEY } from '@domain/buildings';
import { FLOORPLANS_KEY } from '@domain/floorplans';
import { UseMutation, useMutationWrapper } from '@hooks/useMutationWrapper';
import { deleteFloorplan } from '@services/floorplans/floorplansService';
import { useQueryClient } from 'react-query';

const useDeleteFloorplan = (
  venueId: string,
  buildingId: string
): UseMutation<void, Error, string, unknown> => {
  const queryClient = useQueryClient();

  return useMutationWrapper<void, Error, string>(
    (floorplanId) => deleteFloorplan(floorplanId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(FLOORPLANS_KEY(venueId, buildingId));
        queryClient.invalidateQueries(BUILDINGS_QUERY_KEY(venueId));
      }
    }
  );
};

export { useDeleteFloorplan };
